export enum ClaimType {
  NONE = 0,
  ADD_HALF_OFFICE = 1,
  ADD_FULL_OFFICE = 2,
  ADD_HALF_PARKING = 3,
  ADD_FULL_PARKING = 4,
  CIRCUIT = 5,
}
